export default __webpack_public_path__ + "static/media/plus_button.bda965d8.png";